module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberHome",
    staticStyle: {
      "height": "100%",
      "background-color": "#EFEFEF"
    }
  }, [_c('view-box', {
    ref: "viewbox",
    attrs: {
      "body-padding-top": _vm.headShow ? '46px' : ''
    }
  }, [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "loading-box"
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "position": "absolute"
    }
  })], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerShow),
      expression: "footerShow"
    }]
  }, [_c('tabbar-item', {
    attrs: {
      "selected": _vm.$route.path === '/portal/portalIndex',
      "link": {
        path: '/portal/portalIndex',
        query: {
          isJump: 1
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../assets/images/icon/store2@2x.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "icon-active",
      "src": require("../assets/images/icon/store1@2x.png")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("积分")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d98fa50"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/memberHome.vue
// module id = 452
// module chunks = 1